import { Component, computed, inject, input } from '@angular/core';

import { FinnairThemeService } from '@fcom/common';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { CmsCollection, CmsContent } from '@fcom/core-api/interfaces/cms-interface';

@Component({
  selector: 'cms-unique-selling-point',
  styleUrls: ['./cms-unique-selling-point.component.scss'],
  templateUrl: './cms-unique-selling-point.component.html',
  standalone: false,
})
export class CmsUniqueSellingPointComponent {
  private themeService = inject(FinnairThemeService);

  readonly isNewBrand = computed(() => {
    return this.themeService.siteTheme() !== FinnairTheme.LEGACY;
  });

  content = input.required<CmsCollection>();

  items = computed((): CmsContent[] => {
    return this.content()?.items ?? [];
  });
}
